import hljs from 'highlight.js/lib/core';

import bash from 'highlight.js/lib/languages/bash';
import java from 'highlight.js/lib/languages/java';
import javascript from 'highlight.js/lib/languages/javascript';
import json from 'highlight.js/lib/languages/json';
import python from 'highlight.js/lib/languages/python';

interface HighlightJs {
    highlightBlock: (block: HTMLElement) => void;
    //lineNumbersBlock: (block: HTMLElement) => void;
    registerLanguage: (name: string, language: any) => void;
}

declare global {
    interface Window {
        hljs: HighlightJs;
    }
}

window.hljs = hljs;

hljs.registerLanguage('bash', bash);
hljs.registerLanguage('java', java);
hljs.registerLanguage('javascript', javascript);
hljs.registerLanguage('json', json);
hljs.registerLanguage('python', python);
